import { NgModule } from '@angular/core';

import { ImageCarouselDialogComponent } from './image-carousel-dialog.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  exports: [ImageCarouselDialogComponent],
  declarations: [ImageCarouselDialogComponent],
  providers: [],
})
export class ImageCarouselDialogModule { }
